export const apiUrl = `${process.env.REACT_APP_baseUrl}`;
//export const apiUrl = 'https://api-quantimqa.sura-im.com/';
